import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../common/store'
import { getLaiskeyFromPath } from '../../common/util'
import { getPlanningData } from './slice'

export function usePlanningData() {
  const location = useLocation()
  const planningData = useAppSelector(getPlanningData)
  const laisKey = getLaiskeyFromPath(location.pathname, true)
  return planningData?.parcelPlanningItem?.laisKey === laisKey ? planningData : null
}